import { SCHEDULER_VIEW_PLANS_COLUMNS, SCHEDULE_VIEW_FILTER_FIELD_CONFIG } from "./SchedulerView/schedulerViewPlansColumnsData.jsx";
import SwivuCellEditor from "../../bryntum-lib/widget/fields/SwivuCellEditor.jsx";
import {
  cellMenuItemAdjustPoints,
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow,
  cellMenuItemRemoveRow,
  cellMenuItemSettingsEditor,
  cellMenuItemToggleArchiveRow,
  entityCategorySelector,
  entityCellTaskColor,
  entityCellTaskStyle,
  entityPhaseSelector,
  entityStatusSelector,
  entityTagsSelector,
  entityTeamSelector
} from "../utils/gridCellMenuUtils.jsx";
import { SWIVU_GROUP_CONTEXT_MENU_SELECTOR, SWIVU_TOOLTIP_TRIGGER_CLS } from "./OtherKeys.jsx";
import { gridHeaderMenuProcessItems } from "../utils/otherUtils.jsx";

const TASK_VIEW_GRID_CONFIG = {
  columns: SCHEDULER_VIEW_PLANS_COLUMNS,
  cls: "swivu-unplanned-grid",
  subGridConfigs: {
    locked: {
      width: 300,
      weight: 20
    },
    normal: {
      weight: 30
    }
  },
  filterFeature: {
    pickerConfig: {
      fields: SCHEDULE_VIEW_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  regionResizeFeature: true,
  preserveScrollOnDatasetChange: true,
  statefulEvents: ['subGridCollapse', 'subGridExpand', 'horizontalScroll', 'stateChange', 'scroll', 'swivuTaskStoreFilter', 'swivuTaskStoreSort', 'swivuTaskStoreGroup'],
  rowReorderFeature: {
    dragHelperConfig: {
      // prevent reordering in task grid when dragging task to the schedule
      allowDropOutside: false
    }
  },
  rowCopyPasteFeature: false,
  cellEditFeature: { editorClass: SwivuCellEditor },
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      filterMenu: false,
      removeRow: cellMenuItemRemoveRow(),
      archive: cellMenuItemToggleArchiveRow(),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      settingsEditor: cellMenuItemSettingsEditor(),
      entityPhaseSelector: entityPhaseSelector(),
      entityStatusSelector: entityStatusSelector(),
      entityCategorySelector: entityCategorySelector(),
      entityTagsSelector: entityTagsSelector(),
      entityTeamSelector: entityTeamSelector(),
      entityTaskColor: entityCellTaskColor(),
      entityCellTaskStyle: entityCellTaskStyle(),
      adjustPoints: cellMenuItemAdjustPoints()
    },
  },
  headerMenuFeature: {
    processItems: gridHeaderMenuProcessItems("lockedRegion", "normalRegion")
  },
  cellTooltipFeature: {
    minWidth: "35em",
    maxHeight: "40em",
    scrollable: true,
    contentElementCls: "!m-0 !p-[1em]",
    forSelector: `.${SWIVU_TOOLTIP_TRIGGER_CLS}`,
    allowOver: true,
    dismissDelay: 0,
  }
  // Store will be created automatically, `syncDataOnLoad` is `true` by default (set in the wrapper)
  // store : {
  //   readUrl : ENV.API_BASE_URL + "/board/test-board", // When Grid finds readUrl in the store config it will create an AjaxStore
  //   id : "tasks",
  //   autoLoad : true // Load upon creation
  // }
};

export { TASK_VIEW_GRID_CONFIG };
